import React from 'react';
import { connect } from 'react-redux';


function Branding({config}) {


  return (
    <React.Fragment>
        <link rel="stylesheet" href={"https://app.cordero.cloud/css/quote/brand/" + config.app_id + ".css"} />
    </React.Fragment>
  );
}


const mapStateToProps = (state) => {
  return {
    config: state.config,
  };
}

export default connect(mapStateToProps)(Branding);
